// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"936d4d50","732":"25755591","916":"191edea6"}[chunkId] + ".chunk.js";
};